import AmexExperientialBannerCarousel from './AmexExperientialBannerCarousel';

export default AmexExperientialBannerCarousel;
